import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f32ed12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-wrapper" }

import { ref, watch } from "vue";
import NavBar from "@/components/NavBar.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailLayout',
  setup(__props) {

const route = useRoute();
const navTitle = ref("");

navTitle.value = route.meta.title as string;

watch(() => route.name, () => {
  navTitle.value = route.meta.title as string;
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(NavBar, { title: navTitle.value }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})